import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import './Footer.css'; 
import facebookIcon from "../../assets/facebook.png";
import instagramIcon from "../../assets/instagram.png";
import tiktokIcon from "../../assets/tiktok.png";

const Footer = () => {
  const { lang } = useLanguage(); // make sure it's consistent

  const labels = {
    en: { rights: "All rights reserved", contact: "Contact us", follow: "Follow Us" },
    sq: { rights: "Të gjitha të drejtat e rezervuara", contact: "Na kontaktoni", follow: "Na Ndiqni" },
  };

  const text = lang === "sq" ? labels.sq : labels.en;

  return (
    <footer className="footer">
      <div className="footer-social">
        <h2>{text.follow}</h2>
        <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <img src={facebookIcon} alt="Facebook" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="Instagram" />
          </a>
          <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">
            <img src={tiktokIcon} alt="TikTok" />
          </a>
        </div>
      </div>
      <p className="footer-text">
        {text.rights} | <a href="/contact">{text.contact}</a>
      </p>
    </footer>
  );
};

export default Footer;